import React, { useCallback, useRef } from 'react';
import { BackendWebSocketContext } from './BackendWebSocketContext';

const BackendWebSocketProvider = ({ children }) => {
  const handlers = useRef(new Map());

  const registerHandler = useCallback((key, handler) => {
    handlers.current.set(key, handler);
  }, []);

  const unregisterHandler = useCallback((key) => {
    handlers.current.delete(key);
  }, []);

  const dispatchMessage = useCallback((data) => {
    if (!data) return;
    handlers.current.forEach(handler => handler(data));
  }, []);

  return (
    <BackendWebSocketContext.Provider value={{ dispatchMessage, registerHandler, unregisterHandler }}>
      {children}
    </BackendWebSocketContext.Provider>
  );
};

export default BackendWebSocketProvider;
